import {Component, EventEmitter, OnInit, OnDestroy, HostListener} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import { SessionServiceService } from './services/session-service.service';
import { LoggerService } from "./services/logger/logger.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy  {
  constructor(
    private _logger: LoggerService,
  ) {
  }

  // handle logging when the app/tab/window is closed
  @HostListener('window:beforeunload', [ '$event' ])
  ngOnDestroy() {
    this._logger.handleOnDestroy();
  }
}

export function hasObservers(observable: Subject<any> | EventEmitter<any>): boolean {
  return observable.observers.length > 0;
}
